import component from "frontend/legacy/unavailable-message"

export default component
